import Int32LookupResourceModel from '../../generated/types/model/resource/Int32LookupResourceModel';

export default class Int32LookupResourceViewModel extends Int32LookupResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
